import "./case-status.scss";
import { ApplicationStatusEnum } from "../../../../models/enum/application-status.enum";
import { SolicitorCaseStatusEnum } from "../../../../models/enum/solicitor-case-status.enum";
import { getSolicitorCaseStatus } from "../../../../utils/string-formatter";
import { HtmlHTMLAttributes } from "react";

interface CaseStatusProps extends HtmlHTMLAttributes<HTMLDivElement> {
  status: ApplicationStatusEnum;
  lodgementDate?: string;
}

export function CaseStatus({ status, lodgementDate, ...props }: CaseStatusProps) {
  const solicitorCaseStatus = getSolicitorCaseStatus(status, lodgementDate);
  if (solicitorCaseStatus === SolicitorCaseStatusEnum.invalid) {
    return null;
  }
  const className = getClassName(solicitorCaseStatus);
  return (
    <div className={`polymer-case-status polymer-case-status__${className}`} {...props}>
      {solicitorCaseStatus}
    </div>
  );
}

function getClassName(status: SolicitorCaseStatusEnum): string {
  switch (status) {
    case SolicitorCaseStatusEnum.pending_ipa:
      return "pending";
    case SolicitorCaseStatusEnum.pending_lodgement:
      return "lodgement";
    case SolicitorCaseStatusEnum.ipa_received:
      return "received";
    case SolicitorCaseStatusEnum.cancelled:
      return "cancelled";
    case SolicitorCaseStatusEnum.rejected:
      return "rejected";
    case SolicitorCaseStatusEnum.completed:
      return "completed";
    default:
      return "";
  }
}
